import Vue from 'vue'
import Router from 'vue-router'
import routes from './map'
Vue.use(Router)

const router = new Router({
	mode: location.href.indexOf('www.transfelicia.co') >= 0 ? 'history' : 'hash',
	base: process.env.BASE_URL,
	routes,
})
console.log('process.env.BASE_URL---', process.env.BASE_URL)

export default router
